export function initChangeAvatar() {
	const form = document.getElementById('change-avatar-form');
	const saveBtn = document.querySelector('[data-action="save-avatar"]');

	if (!form || !saveBtn) return;

	const fileInput = document.getElementById('avatar-upload');
	const preview = document.getElementById('avatar-preview');

	// Handle file selection (Preview & Client Validation)
	if (fileInput) {
		fileInput.addEventListener('change', function (e) {
			const file = e.target.files[0];

			if (!file) {
				saveBtn.disabled = true;
				return;
			}

			// Validate file type
			const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
			if (!validTypes.includes(file.type)) {
				if (window.wpcore && window.wpcore.alert) {
					window.wpcore.alert('error', wpcore.direct_t({ en: 'Update Avatar', fr: 'Mettre à jour l\'avatar' }), wpcore.direct_t({ en: 'Only JPG, JPEG and PNG files are allowed', fr: 'Seulement les fichiers JPG, JPEG et PNG sont autorisés' }));
				}
				saveBtn.disabled = true;
				return;
			}

			// Validate file size (20MB)
			const maxSize = 20 * 1024 * 1024; // 20MB in bytes
			if (file.size > maxSize) {
				if (window.wpcore && window.wpcore.alert) {
					window.wpcore.alert('error', wpcore.direct_t({ en: 'Update Avatar', fr: 'Mettre à jour l\'avatar' }), wpcore.direct_t({ en: 'File size must be less than 20MB', fr: 'La taille du fichier doit être inférieure à 20MB' }));
				}
				saveBtn.disabled = true;
				return;
			}

			// Preview image
			const reader = new FileReader();
			reader.onload = function (e) {
				preview.src = e.target.result;
			};
			reader.readAsDataURL(file);

			// Enable save button
			saveBtn.disabled = false;
		});
	}

	// Handle save button click via AJAX
	saveBtn.addEventListener('click', async function (e) {
		e.preventDefault();

		// Disable button and show loading state
		saveBtn.disabled = true;
		const originalText = saveBtn.textContent;
		saveBtn.textContent = wpcore.direct_t({ en: 'Uploading...', fr: 'T\u00e9l\u00e9versement...' });

		try {
			const formData = new FormData(form);
			formData.append('action', 'save_avatar');

			const response = await fetch(wpcore.ajaxUrl, {
				method: 'POST',
				body: formData
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const result = await response.json();
			const message = result.data?.message;

			if (result.success) {

				if (window.wpcore && window.wpcore.alert) {
					window.wpcore.alert('success', wpcore.direct_t({ en: 'Update Avatar', fr: 'Mettre \u00e0 jour l\'avatar' }), message);
				}

				// Update any other avatar elements on the page
				if (result.data?.avatar_url) {
					document.querySelectorAll('.js-user-avatar').forEach(img => {
						img.src = result.data.avatar_url;
					});
					preview.src = result.data.avatar_url;
				}

				// Close popup if inside one
				if (window.wpcore && typeof window.wpcore.closePopup === 'function') {
					window.wpcore.closePopup('change-avatar');
				}
			} else {
				if (window.wpcore && window.wpcore.alert) {
					window.wpcore.alert('error', wpcore.direct_t({ en: 'Update Avatar', fr: 'Mettre à jour l\'avatar' }), message);
				}
			}
		} catch (error) {
			console.error('Avatar upload failed:', error);
			const errorMsg = wpcore.direct_t({ en: 'An error occurred while uploading. Please try again.', fr: 'Une erreur est survenue lors du téléversement. Veuillez réessayer.' });
			if (window.wpcore && window.wpcore.alert) {
				window.wpcore.alert('error', wpcore.direct_t({ en: 'Update Avatar', fr: 'Mettre à jour l\'avatar' }), errorMsg);
			}
		} finally {
			// Re-enable button
			saveBtn.disabled = false;
			saveBtn.textContent = originalText;
		}
	});
}
